import { Settings } from './types';

export const settings_default: Settings = {
  loading: false,
  loading_component: false,
  offset_navigation: 56,
  previous: null,
  current: null,
};
